import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Event from "@/pages/Event";
import AboutUs from "@/pages/AboutUs";
import Articles from "@/pages/Articles";
import Article from "@/pages/Article";
import Collaborators from "@/pages/Collaborators";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/eveniment" element={<Event />} />
          <Route path="/cine-suntem" element={<AboutUs />} />
          <Route path="/articole" element={<Articles />} />
          <Route path="/articole/:slug" element={<Article />} />
          <Route path="/colaboratori" element={<Collaborators />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
